export const DELETE_ACCOUNT_REQUESTED = "DELETE_ACCOUNT_REQUESTED";
export const DELETE_ACCOUNT_RECEIVED = "DELETE_ACCOUNT_RECEIVED";
export const DELETE_ACCOUNT_REQUEST_FAILED = "DELETE_ACCOUNT_REQUEST_FAILED";
export const DELETE_ACCOUNT_REQUEST_RESET = "DELETE_ACCOUNT_REQUEST_RESET";

export const CONFIRM_DELETE_ACCOUNT_REQUESTED = "CONFIRM_DELETE_ACCOUNT_REQUESTED";
export const CONFIRM_DELETE_ACCOUNT_RECEIVED = "CONFIRM_DELETE_ACCOUNT_RECEIVED";
export const CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED = "CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED";

export const requestDeleteAccount = () => ({ type: DELETE_ACCOUNT_REQUESTED });
export const receiveDeleteAccount = () => ({ type: DELETE_ACCOUNT_RECEIVED });
export const resetDeleteAccount = () => ({ type: DELETE_ACCOUNT_REQUEST_RESET });

export const requestConfirmDeleteAccount = confirmationToken => ({
  type: CONFIRM_DELETE_ACCOUNT_REQUESTED,
  confirmationToken
});
export const receiveConfirmDeleteAccount = () => ({ type: CONFIRM_DELETE_ACCOUNT_RECEIVED });
